module.exports = __webpack_public_path__ + "img/7.58ef3ab5.jpg";